// -*- Mode: rjsx -*-
import React from 'react';
import axios from 'axios';

import { Spinner } from '../ui/Spinner';
import  FancyDate  from '../ui/FancyDate';
import Morty from '../data/Morty';

const sharedFormStyle = {
    f: {
        width: 500,
        margin: "auto",
        border: "solid 1px #ccc",
        borderRadius: 5
    },
    c: {
        padding: 10,
    },
    l: {
        borderBottom: "solid 1px #eee"
    },
    i: {
        padding: 5,
        width: 480,
    },
    v: {
        paddingTop: 5
    },
    p: {
        paddingBottom: 10,
        textAlign: "left"
    },
    submit: {
        paddingTop: 5,
        textAlign: "center"
    },            
    instructions: {
        fontSize: "120%",
        textAlign: "center",
        lineHeight: "130%",
        padding: 15
    }
};

class DwollaCustomerForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: this.props.firstName || '',
            lastName: this.props.lastName || '',
            email: this.props.email || '',
            type: "receive-only",
            businessName: this.props.businessName || '',
            saving: false
        };
        this.onUpdate = this.onUpdate.bind(this);
        this.save = this.save.bind(this);        
    }

    onUpdate(e) {
        e.preventDefault();
        let field = e.target.name;
        let value = e.target.value;        
        this.setState({ [field]: value });
    }

    save() {
        this.setState({ saving: true });
        this.props.onSave(this.state);
    }
    
    render() {
        let s = sharedFormStyle;

        return (
            <div style={s.f}>
              
              <div style={s.instructions}>
                <p>We use a company called Dwolla to handle payments. </p>
                <p>In order to do this, we need to share some information with them. Please verify the following information, which we'll send to Dwolla.</p>
              </div>

              
              
              <div style={s.c}>
		<div style={s.l}>First Name</div>                
                <div style={s.v}><input type="text" style={s.i} name="firstName" value={this.state.firstName} onChange={this.onUpdate} /></div>
              </div>
              
              <div style={s.c}>
		<div style={s.l}>Last Name</div>                
                <div style={s.v}><input type="text" style={s.i}  name="lastName" value={this.state.lastName} onChange={this.onUpdate} /></div>
              </div>
              
              <div style={s.c}>
		<div style={s.l}>Email <small>(it can be different from your Fancy Hands email)</small></div>                
                <div style={s.v}><input type="text" style={s.i}  name="email" value={this.state.email} onChange={this.onUpdate} /></div>
              </div>

              
	      <div style={s.c}>
		<div style={s.l}>Only click this one</div>
	        <div style={s.submit}>{ this.state.saving ? <em>Saving...</em> : <input type="submit" className="button blue" value="Save and Send to Dwolla" onClick={this.save}/> }</div>
	      </div>
              
            </div>
        );

    }
}


class MustBeOnDwollaSetup extends React.Component {

    render() {
        return (
            <div className="notice">
              <p style={{ marginBottom: 16 }}>
                You need to set up your payment information.
              </p>
              <p>
                <a className="button blue" href="/admin/dwolla-setup">Set that up now</a>
              </p>
            </div>
        );
    }
}
    
class DwollaCreateCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.onSave = this.onSave.bind(this);
    }


    

    onSave(data) {
	Morty.post('/morty/dwolla/customer/', data)
	    .then((data) => {
                window.location.href='/admin/dwolla-setup?msg=Updated';
            
	    })
            .catch((data) => {
                alert("There was an issue creating your account on Dwolla: " + data.response.data.message + " Refresh this page and try again.");
            });
    }
    
    render() {
        let user = this.props.user;

        if(!this.props.onSetupPage) {
            return <MustBeOnDwollaSetup />;
        }

        
        return <DwollaCustomerForm onSave={this.onSave} firstName={user.first_name} lastName={user.last_name}  />;
    }
}


class DwollaSingleSource extends React.Component {
    constructor(props) {
        super(props);
        this.verifyDelete = this.verifyDelete.bind(this);
    }

    verifyDelete() {
        if(confirm("Are you sure you want to remove your banking information? We won't be able to pay you without it.")) {
	    Morty.post('/morty/dwolla/remove-funding-source/', { funding_location: this.props.source._links.self.href } )
	        .then((data) => {
                    if(data.error) {
                        alert(data.message);
                    }
                    else {
                        window.location.href='/admin/dwolla-setup?msg=Removed';
                    }
                    
                });
        }
        
    }
    render() {
        let source = this.props.source;
        let s = {
            main: {
                padding: 16,
                border: "solid 1px #ccc",
                borderRadius: 5,
                margin: "auto",
                width: 500,
                paddingTop: 70,
                paddingBottom: 25,                
                backgroundImage: "url(/images/gifts/money-theme.jpg)"
            },
            name: {
                fontWeight: "bold"
            },
            bankName: {
                textTransform: "uppercase",
                color: "#333"
            }            
        };
        

        // let isDefault = this.props.defaultSource && this.props.defaultSource.indexOf(source.id) !== -1;
        return (
            <div style={s.main} key={source.id}>
              <div style={s.name}>{ source.name } </div>
              <div style={s.bankName}>{ source.bankName }</div>
              <div style={s.actions}><a href="javascript://" onClick={() => this.verifyDelete() }>Remove</a></div>
            </div>
        );
        
    }
}

class DwollaSources extends React.Component {

    render() {
        let sources = this.props.sources.map((s) => {
            return <DwollaSingleSource source={s} key={s.id}
                                       defaultSource={this.props.defaultSource} />;
        });
        
        if(!sources.length) {
            sources = [<em key="none">None Yet</em>];
        }

        let s = {
            padding: 16
        };
        return (
            <div style={s}>
              <h2>All Payments Will Go To</h2>
              { sources }
            </div>
        );
    }
    
}


class DwollaSourceForm extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            accountNumber: "",
            routingNumber: "",
            bankAccountType: "checking",
            name: "",
            saving: false
        };
        this.onUpdate = this.onUpdate.bind(this);
        this.save = this.save.bind(this);        
    }

    save() {
        let self = this;
        this.setState({ saving: true });
        Morty.post('/morty/dwolla/sources/', this.state)
            .then((u) => {
                if(self.props.onSave) 
                    self.props.onSave(u);                
                // self.setState({ sources: data });
            })
            .catch((data) => {
                this.setState({saving: false });
                alert("There was an issue on Dwolla: " + data.response.data.message + " Try again.");
            });        
    }
    
    onUpdate(e) {
        e.preventDefault();
        let field = e.target.name;
        let value = e.target.value;        
        this.setState({ [field]: value.toString() });
    }

    receiveOnlyChange() {
        alert("This form only allows Fancy Hands to send money to you. This form does not allow Fancy Hands to withdraw money from your account. This is how you get paid.");
    }
    
    render() {
        let s = sharedFormStyle;

        
        if(!this.props.onSetupPage) {
            return <MustBeOnDwollaSetup />;
        }
        
        return (
            <div>
              <h2>Add a new Bank Account</h2>
              
              <div style={s.f}>
                
                <div style={s.instructions}>
                  <p style={s.p}>In order to pay you, we need your <strong>routing</strong> and bank <strong>account</strong> numbers. The easiest way to find this is by looking at one of your checks.</p>
                  <p style={s.p}>This information is sent securely to Dwolla where they store it. This information is never stored in Fancy Hands servers.</p>
                  <p style={s.p}>This requires a <strong>valid US bank account</strong> (checking or savings). Pre-paid cards may not work.</p>
                  <p style={s.p}>We will never charge you for anything, this is only used to send you payments.</p>
                  <p style={s.p}>
                    <img src="/images/bank-routing.jpg" alt="An example check showing where to find your routing and bank account numbers" />
                  </p>
                </div>

                <div style={s.c}>
		  <div style={s.l}>Routing Number</div>                
                  <div style={s.v}><input type="text" style={s.i} name="routingNumber" placeholder="123456789" value={this.state.routingNumber} onChange={this.onUpdate} /></div>
                </div>
                
                <div style={s.c}>
		  <div style={s.l}>Account Number</div>                
                  <div style={s.v}><input type="text" style={s.i} name="accountNumber" value={this.state.accountNumber} onChange={this.onUpdate} /></div>
                </div>

                <div style={s.c}>
		  <div style={s.l}>Bank Account Type</div>                
                  <div style={s.v}>
                    <select name="bankAccountType" onChange={this.onUpdate}>
                      <option value="checking">Checking</option>
                      <option value="savings">Savings</option>
                    </select>
                  </div>
                </div>                  

                <div style={s.c}>
		  <div style={s.l}>Name (this is just for your reference)</div>                
                  <div style={s.v}><input type="text" style={s.i} name="name" placeholder="My Checking Account" value={this.state.name} onChange={this.onUpdate} /></div>
                </div>

                <div style={s.c}>
		  <div style={s.l}>We will never charge you to be an assistant, we'll only send money to you</div>                
                  <div style={s.v}><input type="checkbox" readOnly name="receive-only" checked id="receive-only" onClick={this.receiveOnlyChange} /> <label htmlFor="receive-only" >I agree and understand, I am 18 or older and Fancy Hands can send money to me.</label> </div>
                </div>


                <div style={s.c}>
		  <div style={s.l}>Check your work</div>                
                  <div style={s.v}><strong>Please take an extra moment to verify this information is correct</strong> </div>
                </div>
                
	        <div style={s.c}>
		  <div style={s.l}>&nbsp;</div>
	          <div style={s.submit}>
                    { this.state.saving ? <em>Saving, this may take a second...</em> : <input type="submit" className="button blue" value="Save" onClick={this.save}/> }
                  </div>
	        </div>

              </div>
            </div>
        );

    }
}

class DwollaTransaction extends React.Component {
    render() {
        let transaction = this.props.transaction;
        let s = {
            amount: {
                fontSize: "200%",
                display: "inline-table",
                justifyContent: 'center',
                width: 150,
                textAlign: "right",
            },
            otherData: {
                display: "inline-table",
                textAlign: "left",
                marginLeft: 8,
                width: 250                
            },
            status: {
            },
            date: {
            },            
        };
        
        return(
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: 16 }}>
              <div style={s.amount}>${transaction.amount.value }</div>
              <div style={s.otherData}>
                <div style={s.status}>
                  Status: { transaction.status }
                </div>
                <div style={s.date}>
                  Sent: <FancyDate date={ transaction.created } />
                </div>
              </div>
            </div>
        );
    }
}

class DwollaTransactions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            next_page: null,
            transactions: null
        };
    }
    
    componentDidMount() {
        this.loadTransactions();
    }

    loadTransactions() {
        let self = this;

        Morty.get('/morty/dwolla/transactions')
            .then((data) => {
                if(self.state.user.is_manager) {
                    this.setState({
                        transactions: [
                            {
                                id: "fake-transaction-for-manager",
                                amount: {
                                    value: "23.03",
                                },
                                status: "pending",
                                created: "2018-12-03T02:12:12Z"
                            },
                            {
                                id: "fake-transaction-for-manager2",
                                amount: {
                                    value: "34.23",
                                },
                                status: "processed", 
                                created: "2018-11-03T02:12:12Z"
                            },
                            {
                                id: "fake-transaction-for-manager3",
                                amount: {
                                    value: "05.23",
                                },
                                status: "these-are-example-transactions",
                                created: "2018-10-03T02:12:12Z"
                            }                            
                            
                        ]
                    });
                }
                else {
                    self.setState({'transactions': data.transactions });
                }

            });
    }
    
    render() {
        let transactions = (this.state.transactions === null ? <Spinner text="Loading Transactions"/> : this.state.transactions.map((t) => <DwollaTransaction key={t.id} transaction={t}/>));
        return (
            <div>
              <h2>Payments</h2>
              { transactions }
            </div>
        );
    }
    
}

class DwollaSetupMain extends React.Component {
    constructor(props) {
	super(props);
        let user = window.pageVariables.user;
	this.state = {
	    user: user,
            sources: null,
            showNew: null,
            defaultSource: null
        };
        if(window.location.href.indexOf('dwolla-setup') !== -1) {
            Morty.setTitle("Dwolla Setup");
        }
        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        if(this.state.user.dwolla_customer_location) {
            this.loadSources();        
        }        
    }

    onSave() {
        window.location.href = "/admin/dwolla-setup?msg=Awesome.+You+are+all+set.";
    }

    loadSources() {
        let self = this;
        Morty.get('/morty/dwolla/sources/')
            .then((data) => {
                self.setState({
                    sources: data.sources,
                    defaultSource: data.default,
                    showNew: (this.state.showNew === true || !data.sources.length ? true : false)
                });
            });
    }
        
    render() {

	if(!this.state.user) {
	    window.location.href = '/admin?msg=Not+logged+in?';
	    return <Spinner text="User Error" />;
	}

        let onSetupPage = window.location.href.indexOf('dwolla-setup') !== -1;
        
        
	if(!this.state.user.dwolla_customer_location) {
            return <DwollaCreateCustomer onSetupPage={onSetupPage}  user={this.state.user} />;
	}
        else if(this.state.sources === null) {
            return <Spinner text="Securely loading bank information" />;
        }
        else {
            let showNewToggle = null;
            if(this.state.showNew && this.state.sources.length) {
                showNewToggle = (
                    <p>
                      Your payment information is set up. This means we can pay you.
                    </p>
                );
            }
            
            return (
                <div>
                  <DwollaSources onSetupPage={onSetupPage} sources={this.state.sources} defaultSource={this.state.defaultSource} />
                  { showNewToggle }
                  { this.state.showNew ? <DwollaSourceForm onSetupPage={onSetupPage} onSave={this.onSave}  /> : null }
                  <DwollaTransactions user={this.state.user} />
                  <div style={{ lineHeight: "150%", width: "80%", margin: "auto", marginTop: 16 }}>
                    <p>The status of the payments will go from "pending" to "processed" over a couple of days. </p>
                    <p>It generally takes 3-5 business days for the funds to hit your bank account.</p>
                    <p>If it's listed here, it's working it's way through the banking network.</p>                  
                    <p>If you have questions about this. Please <a href="/admin/payments">contact us with the instructions listed here</a>. </p>
                  </div>
                </div>
            );

        }
    }
}

class DwollaSetup extends React.Component {
    render() {
        let style = {
            textAlign: "center"
        };
        return(<div style={style}><DwollaSetupMain /></div>);
    }
}
export default DwollaSetup;
